module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Learn"
  }, [_c('transition', {
    attrs: {
      "name": "Learn-container-"
    }
  }, [_c('div', {
    key: _vm.activeItem.id,
    staticClass: "Learn-container"
  }, [_c('div', {
    staticClass: "Learn-header"
  }, [(_vm.activeItem.content.supertitle) ? _c('p', {
    staticClass: "Learn-supertitle t-caps",
    domProps: {
      "innerHTML": _vm._s(_vm.activeItem.content.supertitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeItem.content.title) ? _c('p', {
    staticClass: "Learn-title t-headingMd",
    domProps: {
      "innerHTML": _vm._s(_vm.activeItem.content.title)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "Learn-content"
  }, [_c(_vm.activeItem.template, {
    tag: "component",
    attrs: {
      "content": _vm.activeItem.content
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "Learn-footer"
  }, [(_vm.activeItem.buttons) ? _c('div', {
    staticClass: "Learn-buttons"
  }, _vm._l((_vm.activeItem.buttons), function(button) {
    return _c('div', {
      staticClass: "Learn-button",
      on: {
        "click": _vm.nextItem
      }
    }, [_c('button-component', [_vm._v("\n              " + _vm._s(button.label) + "\n            ")])], 1)
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Learn-dots"
  }, _vm._l((_vm.dots), function(item, index) {
    return _c('div', {
      staticClass: "Learn-dot",
      class: _vm.learnDotClass(item, index)
    })
  }))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46b01e4f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Learn/Learn.vue
// module id = 824
// module chunks = 1